export default __webpack_public_path__ + "static/media/config_4.52452d00.png";